module.exports = __webpack_public_path__ + "static/media/album-dark.ca51ff90.svg";